

<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/servizionline">SERVIZI ONLINE</a></span></li>
            <li class="last"><span><a href="/sirang/geoportale">Geoportale</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      
      <div id="iframe"> 
         <iframe frameborder="0" id="embeddedIframe"  [src]="geoportalUrl" width="100%" class="aui-resizeiframe-monitored-height" style="height: calc(100vh - 10.3em);"></iframe> 
      </div>
      <form action="#" id="hrefFm" method="post" name="hrefFm"> <span></span> </form>
   </div>
</div>